import { TextField } from "@mui/material";
import image from "../assets/ford.jpg";
import { ArrowBarToUp } from "tabler-icons-react";
import { useContext } from "react";
import MenuContext from "antd/lib/menu/MenuContext";
import TextInput from "../utils/TextInput";

function NewCTA() {
	const { mobileMenu } = useContext(MenuContext);

	return (
		<div
			className={
				mobileMenu
					? "absolute md:left-64 md:top-0 md:w-[calc(100%-16rem)] py-3 h-auto bg-slate-50 dark:bg-darkbg"
					: "absolute top-[3rem] md:left-[13rem] lg:left-64 md:top-0 md:w-[calc(100%-13rem)] lg:w-[calc(100%-16rem)] py-3 h-auto bg-slate-50 dark:bg-darkbg"
			}>
			<h1 className="mb-3 py-1 text-slate-500 dark:text-darktext uppercase font-semibold px-5 border-b border-b-slate-100 dark:border-b-darkborder">
				New CTA
			</h1>
			<div className="flex flex-col px-5">
				<h1 className="text-slate-500 dark:text-darktext font-medium">
					CTA Details
				</h1>
				<div className="flex flex-col mt-3 w-full gap-y-5 pb-10">
					<div className="mb-7">
						<TextInput labelText="Content" multiline minRows={4} />
					</div>
					<span className="space-y-2">
						<span className="text-slate-600 dark:text-darktext">
							Main image
						</span>
						<div className="border dark:border-darkborder bg-white dark:bg-darkbg py-2 pt-0 rounded-md">
							<input
								type="file"
								className="border-b dark:border-b-darkborder block w-full text-sm text-slate-500 file:mr-4 file:py-1 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-sky-50 file:text-sky-500 hover:file:bg-sky-100 px-2 py-1"
								accept="image/jpg,image/png,image/jpeg"
							/>
							<div className="flex justify-center bg-slate-200 dark:bg-darkborder">
								<img
									className="w-[30rem] h-[35rem] py-3 object-cover bg-white"
									src={image}
									alt="main image"
								/>
							</div>
						</div>
					</span>
					<button className="flex items-center text-white bg-green-500 rounded-sm px-2 py-1 hover:bg-green-600 ml-auto">
						<ArrowBarToUp size={17} className="mr-1" /> Publish
					</button>
				</div>
			</div>
		</div>
	);
}

export default NewCTA;
